import dayjs from 'dayjs';

const TIMESTAMP_FORMAT = 'YYYYMMDD_HHmmss';

type RpuFileNameArgs = {
  finessGeo: string;
  numeroOrdre: number;
  /** Identifiant Keycloak (`sub`) de l'utilisateur qui dépose le fichier */
  userId: string;
  /** Nom du fichier d'origine, dont on conserve l'extension (en minuscules) */
  originalName: string;
  date: Date;
};

/** Extension du nom de fichier, sans le point et en minuscules ; vide s'il n'y en a pas. */
const getExtension = (fileName: string): string => {
  const dotIndex = fileName.lastIndexOf('.');
  return dotIndex > 0 ? fileName.slice(dotIndex + 1).toLowerCase() : '';
};

/**
 * Nom d'un fichier RPU déposé manuellement :
 * `M_<FINESS_GEO>_<NUMERO_ORDRE>_<YYYYMMDD>_<HHmmss>_<USER_ID>.<ext>`.
 */
export const buildRpuFileName = ({
  finessGeo,
  numeroOrdre,
  userId,
  originalName,
  date,
}: RpuFileNameArgs): string => {
  const extension = getExtension(originalName);
  const baseName = [
    'M',
    finessGeo.trim(),
    numeroOrdre,
    dayjs(date).format(TIMESTAMP_FORMAT),
    userId,
  ].join('_');
  return extension ? `${baseName}.${extension}` : baseName;
};
